import { Link } from "react-router-dom";
import logo from "../../assets/images/logo-white.svg";
import { RiLoginBoxLine } from "react-icons/ri";
import { useContext, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Profile from "./Header/components/Profile";

export default function Header() {
  const { token } = useContext(AuthContext);
  const [isVisible, setVisible] = useState(false);

  return (
    <div className="h-20 bg-white flex flex-row justify-between items-center pr-5 border-b">
      <div className="flex flex-row items-center  ">
        <div className="flex justify-center items-center  w-24 h-20  bg-toyota border-b border-gray-500">
          <img src={logo} alt="Logo" />
        </div>
        <div className="ml-4 text-blue-900 text-xl font-bold hidden sm:block md:text-xl">
          KARIMJEE - CLAIMS
        </div>
        <span className="ml-4 block sm:hidden text-2xl font-normal text-blue-900">
          KJL
        </span>
      </div>
      <div className="flex flex-row items-center">
        {token ? (
          <div className="z-50">
            <Profile isVisible={isVisible} setVisible={setVisible} />
          </div>
        ) : (
          <Link
            to={"/"}
            className="mx-4 flex justify-center items-center text-blue-900 rounded-md py-1"
          >
            <RiLoginBoxLine color="#FFFFFF" size={22} />
          </Link>
        )}
      </div>
    </div>
  );
}
